"use strict";

function filterProductsBySelect() {
    var filters = {};
    
    $("#filters select").each(function() {
        var category = $(this).data("category");
        var value = $(this).val();
        
        if (value && value !== "all") {
            filters[category] = value;
        }
    });
    
    $("#gallery-grid .gallery-item").each(function() {
        var show = true;
        var classes = $(this).attr("class").split(" ");
        
        for (var key in filters) {
            if (!classes.includes(filters[key])) {
                show = false;
                break;
            }
        }
        
        if (show) {
            $(this).removeClass("hidden").removeClass("invisible");
        } else {
            $(this).addClass("hidden");
        }
    });
    
    setTimeout(function() {
        $("#gallery-grid .gallery-item.hidden").each(function() {
            $(this).addClass("invisible");
        });
    }, 200);
}

function changeText() {
    var btn = $("#btn-filter");
    if (btn.text() === "Filtre") {
        btn.text("Fermer");
    } else {
        btn.text("Filtre");
    }
}

function showCategoryDescription() {
    var selectedValue = $("#filter-type").val();
    var categoryDescription = $("#category-description");
    var categoryDescriptionText = $("#category-description-text");
    
    if (selectedValue && selectedValue !== "all") {
        // Extract the type ID from the value (e.g., "type1" -> "1")
        var typeId = selectedValue.replace("type", "");
        
        // Check if we have descriptions available
        if (window.categoryDescriptions && window.categoryDescriptions[typeId]) {
            var description = window.categoryDescriptions[typeId].description;
            if (description && description.trim() !== "") {
                categoryDescriptionText.html(description);
                categoryDescription.show();
            } else {
                categoryDescription.hide();
            }
        } else {
            categoryDescription.hide();
        }
    } else {
        categoryDescription.hide();
    }
}

// Event listeners
$("#filters select").on("change", function() {
    filterProductsBySelect();
    showCategoryDescription();
});

$(document).ready(function() {
    // Filter toggle functionality
    $("#filter-toggle-button").on("click", function() {
        $("#filters").toggleClass("open");
        $("#filter-toggle-button").toggleClass("actif");
        $(".gallery-overlay").toggleClass("open");
    });
    
    // Gallery overlay click
    $(".gallery-overlay").on("click", function() {
        $(".gallery-overlay").toggleClass("open");
        $("#filters").toggleClass("open");
        $("#filter-toggle-button").toggleClass("actif");
        changeText();
    });
    
    // Search functionality
    $("#search-input").on("keyup", function() {
        var searchTerm = $(this).val().toLowerCase();
        
        $("#gallery-grid .gallery-item").each(function() {
            var title = $(this).find("h5").text().toLowerCase();
            
            if (title.includes(searchTerm)) {
                $(this).removeClass("hidden").removeClass("invisible");
            } else {
                $(this).addClass("hidden");
            }
        });
    });
});